import { AppThunk } from "config/commonTypes";
import { RolesAction, RoleType } from "store/types/roles";
import { routeToSpecificScope } from "../../helpers";
import {
  addLoadingFlag,
  changeMessageLoading,
  subLoadingFlag,
} from "./loading";
import { requestData } from "../../config/services/datasets";
import { SERVER } from "../../config/server.config";

export const replaceRoles = (roles: RoleType[]) => ({
  type: RolesAction.REPLACE_ROLES,
  roles,
});

export const createRole =
  (role: RoleType): AppThunk =>
  async (dispatch, getState) => {
    const scope = routeToSpecificScope(getState().router.location.pathname);
    const request = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        role: role.role,
        datasets: role.datasets,
        permissions: role.permissions,
      }),
    };
    dispatch(addLoadingFlag(scope));
    const response = await requestData(SERVER.CREATE_ROLE(), request);
    if (response) {
      dispatch(getRoles());
    }
    dispatch(subLoadingFlag(scope));
  };

export const updateRole =
  (role: RoleType): AppThunk =>
  async (dispatch, getState) => {
    const scope = routeToSpecificScope(getState().router.location.pathname);
    const request = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        role: role.role,
        datasets: role.datasets,
        permissions: role.permissions,
      }),
    };
    dispatch(addLoadingFlag(scope));
    await requestData(SERVER.UPDATE_ROLE(role._id), request);
    dispatch(getRoles());
    dispatch(subLoadingFlag(scope));
  };

export const deleteRole =
  (roleId: string): AppThunk =>
  async (dispatch, getState) => {
    const scope = routeToSpecificScope(getState().router.location.pathname);
    const request = {
      method: "DELETE",
      body: JSON.stringify({}),
    };
    dispatch(addLoadingFlag(scope));
    await requestData(SERVER.DELETE_ROLE(roleId), request);
    dispatch(getRoles());
    dispatch(subLoadingFlag(scope));
  };

export const getRoles = (): AppThunk => async (dispatch) => {
  dispatch(addLoadingFlag("CUSTOMERS_ROLES"));
  const results = await requestData(SERVER.GET_ROLES());
  if (results && results.length) {
    dispatch(replaceRoles(results));
  } else {
    dispatch(replaceRoles([]));
    dispatch(
      changeMessageLoading(
        "CUSTOMERS_ROLES",
        "No data matches your specified criteria"
      )
    );
  }
  dispatch(subLoadingFlag("CUSTOMERS_ROLES"));
};
